<template>
  <b-modal id="punch-card-campaign-leave-without-saving-updates-modal" title="Leave without saving changes?" centered
    @hide="clearBody">
    <p class="d-none text-center">Lorem ipsum dolor sit amet consectetur. Mauris et consequat diam aliquet est dolor
      lectus.
    </p>
    <template slot="modal-footer">
      <b-button variant="outline-secondary" class="mr-2" @click="leave">Leave</b-button>
      <b-button variant="primary" @click="saveChanges">Save</b-button>
    </template>
  </b-modal>
</template>

<script>
import { mapFields } from "vuex-map-fields";

export default {
  computed: {
    ...mapFields("punchCard", ["errors"])
  },
  methods: {
    clearBody() {
      document.body.classList.remove("modal-open");
    },
    leave() {
      this.errors = null;
      this.$root.$emit("discardCampaignChanges");
    },
    saveChanges() {
      this.$root.$emit("validateUpdateCampaign");
    }
  }
}
</script>

<style lang="scss">
#punch-card-campaign-leave-without-saving-updates-modal {
  &>.modal-dialog>.modal-content {
    &>.modal-header {
      &>.modal-title {
        width: 100%;
        font-family: MainFontBold, sans-serif;
        text-align: center;
        margin-top: 2.5rem;
      }
    }
  }
}
</style>